<div class="mct-flex mct-col mct-gap-27"  >
  <div>
    {{ 'reports.query-tool.set-filters.filter-tab-description' | translate }}
  </div>
  <p-table [showGridlines]="true" [value]="queryDefinition?.SearchExpressions">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 100px"></th>
        <th style="width: 110px">
          {{ 'reports.query-tool.set-filters.filter-group' | translate | ucfirst }}
        </th>
        <th style="width: 508px">
          {{ 'reports.query-tool.set-filters.filter-field' | translate | ucfirst }}
        </th>
        <th style="width: 140px">
          {{ 'reports.query-tool.set-filters.operator' | translate | ucfirst }}
        </th>
        <th>
          {{ 'common.value' | translate | ucfirst }}
        </th>
        <th style="width: 96px"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-searchExpression let-rowIndex="rowIndex">
      <tr>
        <td>
          <div *ngIf="rowIndex != 0">
            <p-select
              [options]="setOperators"
              [(ngModel)]="searchExpression.SetOperator"
              appendTo="body"
              [style]="{ width: '100%' }"
              (onChange)="filterChanged()"
            ></p-select>
          </div>
        </td>
        <td>
          <p-select
            [options]="groups"
            [(ngModel)]="searchExpression.FilterGroup"
            appendTo="body"
            (click)="groupSelected()"
            [style]="{ width: '100%' }"
            (onChange)="filterChanged()"
          ></p-select>
        </td>
        <td>
          <p-select
            [options]="availableFields"
            [(ngModel)]="searchExpression.Field"
            optionLabel="ReplacementName"
            optionValue="ColumnName"
            appendTo="body"
            [style]="{ width: '100%' }"
            [placeholder]="'common.select-dashes' | translate | titlecase"
            (onChange)="fieldChanged($event, rowIndex)"
          >
          </p-select>
        </td>
        <td>
          <p-select
            *ngIf="searchExpression.FieldType != 'string' && searchExpression.FieldType != 'date'"
            [options]="fieldValueOperators"
            [(ngModel)]="searchExpression.FieldValueOperator"
            appendTo="body"
            [style]="{ width: '100%' }"
            (onChange)="filterChanged()"
          >
          </p-select>
          <p-select
            *ngIf="searchExpression.FieldType == 'string'"
            [options]="stringFieldValueOperators"
            [(ngModel)]="searchExpression.FieldValueOperator"
            appendTo="body"
            [style]="{ width: '100%' }"
            (onChange)="filterChanged()"
          >
          </p-select>
          <p-select
            *ngIf="searchExpression.FieldType == 'date'"
            [options]="dateFieldValueOperators"
            [(ngModel)]="searchExpression.FieldValueOperator"
            appendTo="body"
            [style]="{ width: '100%' }"
            (onChange)="filterChanged()"
          >
          </p-select>
        </td>
        <td>
          <input
            *ngIf="searchExpression.FieldType == 'string'"
            style="width: 100%"
            class="atlas-form-input form-control"
            [(ngModel)]="searchExpression.Value"
            (change)="filterChanged()"
          />
          <input
            *ngIf="searchExpression.FieldType == 'number'"
            type="number"
            style="width: 100%"
            class="atlas-form-input form-control"
            [(ngModel)]="searchExpression.Value"
            (change)="numberChanged(rowIndex)"
          />
          <div class="mct-flex mct-row mct-gap-27" *ngIf="searchExpression.FieldType == 'boolean'"  >
            <p-radioButton name="true" (onClick)="filterChanged()" [(ngModel)]="searchExpression.Value" [value]="'1'" inputId="trueOption">
            </p-radioButton>
            <label for="trueOption">
              {{ 'common.true' | translate | titlecase }}
            </label>
            <p-radioButton
              name="false"
              (onClick)="filterChanged()"
              [(ngModel)]="searchExpression.Value"
              [value]="'0'"
              inputId="falseOption"
            >
            </p-radioButton>
            <label for="falseOption">
              {{ 'common.false' | translate | titlecase }}
            </label>
          </div>
          <div *ngIf="searchExpression.FieldType == 'date' && searchExpression.FieldValueOperator != fieldValueOperatorEnum.InPeriod">
            <wl-date-selector (onDateChanged)="filterChanged()" [(ngModel)]="searchExpression.Value"></wl-date-selector>
          </div>
          <div *ngIf="searchExpression.FieldType == 'date' && searchExpression.FieldValueOperator == fieldValueOperatorEnum.InPeriod">
            <p-select
              [options]="datePeriodOptions"
              [(ngModel)]="searchExpression.Value"
              appendTo="body"
              [style]="{ width: '100%' }"
              [placeholder]="'common.select-dashes' | translate | titlecase"
              (onChange)="filterChanged()"
            >
            </p-select>
          </div>
        </td>
        <td>
          <button pButton type="button" (click)="remove(rowIndex)">{{ 'common.remove' | translate | uppercase }}</button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <button pButton type="button"   (click)="addFilterClicked()">
      {{ 'reports.query-tool.set-filters.add-a-filter' | translate | uppercase }}
    </button>
  </div>
</div>
